import React, { useState } from "react";
import { useSelector } from "react-redux"; // Importa useSelector
import { AiOutlineDown } from "react-icons/ai";
import '../../assets/styles/project-picker.css';
import{ROLES}from '../../cmps/../services/user.service'


export function ProjectPicker({ customHeight, info, field, onUpdate, userRol }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(info.idproyecto);
    const isEditable = userRol === ROLES.ADMIN

    const DataInfo = useSelector(storeState => storeState.infoModulo.infoM)
    const projectOptions = DataInfo?.projectOptions || []; // Ahora usa la información traída desde el API


    function handleProjectChange(ev, project) {
        if (!isEditable) return; // Si no es editable, no hacer nada
        ev.preventDefault();
        setSelectedProject(project.id_proyecto);
        setIsOpen(false);
        onSave(ev, project.id_proyecto);
    }

    function onSave(ev, projectId) {
        onUpdate(ev, field, projectId);
    }
    const selectedOption = projectOptions.find(opt => opt.id_proyecto === selectedProject); // Cambia 'id' por 'id_proyecto'

    // const selectedOption = projectData.find(proj => proj.id_proyecto === selectedProject);

    return (
        <div className="status-picker picker" style={{ alignContent: "center", height: customHeight, width: "170px" }}>
            <div
                className="selected-status"
                onClick={() => isEditable && setIsOpen(!isOpen)} // Solo abrir si es editable
                style={{
                    backgroundColor: selectedOption?.bgColor || '#ffffff',
                    color: selectedOption?.fontColor || '#ffffff',
                    height: customHeight,
                    cursor: isEditable ? 'pointer' : 'not-allowed' // Cambiar cursor según si es editable
                }}
            >
                {selectedOption?.nombre_proyecto || "Seleccione un proyecto"}
                <AiOutlineDown className="dropdown-icon" />
            </div>
            {isOpen && (
                <ul className="status-options">
                    {projectOptions.map(option => (
                        <li
                            key={option.id_proyecto}
                            onClick={(ev) => handleProjectChange(ev, option)}
                            className={option.id_proyecto === selectedProject ? "selected" : ""}
                            style={{ backgroundColor: option.bgColor, color: option.fontColor }}
                        >
                            {option.nombre_proyecto}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

